import { isValidCharacterId } from '@shared/index'
import { createFileRoute } from '@tanstack/react-router'

import PageCharacterOnboarding from '@/pages/PageCharacterOnboarding'

export type CharacterOnboardingSearch = {
  /** Duplicate this character into a new dynamic character. */
  from?: string
  /** Edit this existing dynamic character. */
  character?: string
}

export const Route = createFileRoute('/settings/character-onboarding')({
  component: PageCharacterOnboarding,
  validateSearch: (search: Record<string, unknown>): CharacterOnboardingSearch => ({
    ...(isValidCharacterId(search.from) ? { from: search.from } : {}),
    ...(isValidCharacterId(search.character) ? { character: search.character } : {})
  })
})
